var _g, _rect, _path, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStick6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 309,
    viewBox: "0 0 26 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2211_33894)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 309,
    width: 309,
    height: 26,
    rx: 10,
    transform: "rotate(-90 0 309)",
    fill: "url(#paint0_linear_2211_33894)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 220.227,
    width: 14.2615,
    height: 26,
    transform: "rotate(-90 0 220.227)",
    fill: "#889BD3",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 309C4.47715 309 0 304.523 0 299L0 206H26L26 299C26 304.523 21.5228 309 16 309H10Z",
    fill: "#889BD3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 117.381,
    width: 14.2615,
    height: 26,
    transform: "rotate(-90 0 117.381)",
    fill: "#889BD3",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2211_33894",
    x: -4,
    y: -4,
    width: 34,
    height: 317,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.672092 0 0 0 0 0.759491 0 0 0 0 0.832324 0 0 0 0.212126 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2211_33894"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.375623 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2211_33894",
    result: "effect2_innerShadow_2211_33894"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2211_33894",
    x1: 0,
    y1: 309,
    x2: 0,
    y2: 335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3D4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41454A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStick6);
export default __webpack_public_path__ + "static/media/stick6.6488d02d384f851f10097b36449807a2.svg";
export { ForwardRef as ReactComponent };